import {
  CalendarIcon,
  CircleCrossIcon,
  NeedHelp,
  PlusIcon,
  TimeIcon,
  CheckIcon,
  SendIcon,
  CheckFull,
  EyeFull,
} from "../../../atoms/CustomIcons";
import { useEffect, useState } from "react";
import DashboardTemplate from "../../../templates/Dashboard";
import PotentialDealsHeader from "../../../atoms/PotentialDealsHeader";
import {
  Button,
  Card,
  Checkbox,
  Col,
  DatePicker,
  Row,
  Steps,
  Tooltip,
} from "antd";
import { useAppDispatch, useAppSelector } from "../../../config/hooks";
import {
  getPotentialDealDetails,
  getProposalListing,
  removeProposalData,
} from "../ducks/actions";
import DealsSidebar from "../Components/Sidebar";
import { useNavigate } from "react-router-dom";
import dayjs, { Dayjs } from "dayjs";
import isToday from "dayjs/plugin/isToday";
import isYesterday from "dayjs/plugin/isYesterday";
import ProposalCards from "./ProposalCards";
import DocumentIcon from "../../../atoms/CustomIcons/DocumentIcon";

dayjs.extend(isToday);
dayjs.extend(isYesterday);

export default function DealsDetail() {
  const [loading, setLoading] = useState(false);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [current, setCurrent] = useState(0);
  const location = window.location.pathname;
  const pathSegments = location.split("/");
  const companyId = pathSegments[pathSegments.length - 1];
  const dealId = pathSegments[pathSegments.length - 2];
  const [checklistDates, setChecklistDates] = useState<{
    [key: string]: Date | null;
  }>({
    estimate: null,
    approval: null,
    send: null,
    win: null,
  });
  const dealsDetailData = useAppSelector(
    (state) => state?.potentialDeal?.dealsDetailData
  );
  const proposalListData = useAppSelector(
    (state) => state?.potentialDeal?.proposalListData
  );

  const { Step } = Steps;

  const handleChecklistDateChange = (key: string) => (date: Dayjs | null) => {
    setChecklistDates((prev) => ({
      ...prev,
      [key]: date ? date.toDate() : null,
    }));
  };

  useEffect(() => {
    if (dealId) {
      dispatch(getPotentialDealDetails(dealId));
    }
  }, [dispatch, dealId]);

  useEffect(() => {
    if (dealId && companyId) {
      dispatch(getProposalListing({ company_id: companyId, deal_id: dealId }));
    }
  }, [dispatch, dealId, companyId]);

  useEffect(() => {
    dispatch(removeProposalData());
  }, [dispatch]);

  useEffect(() => {
    if (dealsDetailData?.data) {
      if (dealsDetailData?.data?.status === "in_progress") {
        setCurrent(0);
      }
      if (dealsDetailData?.data?.status === "approval_pending") {
        setCurrent(1);
      }
      if (dealsDetailData?.data?.status === "ready") {
        setCurrent(2);
      }
      if (dealsDetailData?.data?.status === "sent") {
        setCurrent(3);
      }
      if (dealsDetailData?.data?.status === "accepted") {
        setCurrent(4);
      }
      if (dealsDetailData?.data?.status === "lost") {
        setCurrent(4);
      }
    }
  }, [dealsDetailData?.data]);

  return (
    <DashboardTemplate
      loading={loading || dealsDetailData?.loader || proposalListData?.loader}
    >
      <PotentialDealsHeader
        breadcrumb={[
          { label: "Potential deals", href: `/potential-deals/${companyId}` },
          { label: "Potential deal details" },
        ]}
        title={dealsDetailData?.data?.name ?? ""}
        btnText1="Need help?"
        btnIcon1={<NeedHelp />}
        propertyName={dealsDetailData?.data?.property?.name ?? ""}
        propertyClientName={dealsDetailData?.data?.property?.client?.name ?? ""}
        setLoading={setLoading}
        loading={loading}
        detailData={dealsDetailData?.data}
      />

      <div className="deal_detail">
        <Row gutter={16} wrap={false}>
          <Col flex="auto" className="left_area">
            <div className="dealsLeftWrapper">
              <Card className="proposalCard">
                <div className="stepper_box stepper_box_responsive">
                  <div className="stepper" style={{ marginBottom: "20px" }}>
                    <Steps className="custom-steps" current={current}>
                      <Step
                        className="step-1"
                        title={current === 0 ? "In progress" : ""}
                        icon={<TimeIcon />}
                      />
                      <Step
                        className="step-2"
                        title={current === 1 ? "Pending approval" : ""}
                        icon={
                          <Tooltip
                            title={
                              current === 0 ? (
                                <>
                                  <b>Pending approval:</b> Complete estimate and
                                  send for approval.
                                </>
                              ) : (
                                false
                              )
                            }
                          >
                            <EyeFull />
                          </Tooltip>
                        }
                      />
                      <Step
                        className="step-3"
                        title={current === 2 ? "Ready" : ""}
                        icon={
                          <Tooltip
                            title={
                              current === 0 || current === 1 ? (
                                <>
                                  <b>Ready:</b> Complete estimate and mark as
                                  ready.
                                </>
                              ) : (
                                false
                              )
                            }
                          >
                            <CheckIcon />
                          </Tooltip>
                        }
                      />
                      <Step
                        className="step-4"
                        title={current === 3 ? "Sent" : ""}
                        icon={
                          <Tooltip
                            title={
                              current === 0 ||
                              current === 1 ||
                              current === 2 ? (
                                <>
                                  <b>Sent:</b> Proposal is sent to the client.
                                </>
                              ) : (
                                false
                              )
                            }
                          >
                            <SendIcon />
                          </Tooltip>
                        }
                      />
                      <Step
                        className={
                          dealsDetailData?.data?.status === "lost"
                            ? "step-5 lost-step"
                            : "step-5"
                        }
                        title={
                          current === 4
                            ? dealsDetailData?.data?.status === "lost"
                              ? "Lost"
                              : "Accepted"
                            : ""
                        }
                        icon={
                          dealsDetailData?.data?.status === "lost" ? (
                            <CircleCrossIcon />
                          ) : (
                            <Tooltip
                              title={
                                current === 0 ||
                                current === 1 ||
                                current === 2 ||
                                current === 3 ? (
                                  <>
                                    <b>Accepted:</b> Client accepts proposal and
                                    it can be sent to production.
                                  </>
                                ) : (
                                  false
                                )
                              }
                            >
                              <CheckFull />
                            </Tooltip>
                          )
                        }
                      />
                    </Steps>
                  </div>
                  <div className="stepper_content">
                    {proposalListData?.data &&
                      proposalListData?.data?.length > 0 && (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            marginBottom: "16px",
                          }}
                        >
                          <h3
                            style={{
                              fontSize: "22px",
                              lineHeight: "28px",
                              fontWeight: "700",
                              marginBottom: "0px",
                            }}
                          >
                            Proposals
                            {dealsDetailData?.data?.status !== "lost" && (
                              <Button
                                type="primary"
                                className="outlined-btn"
                                onClick={() =>
                                  navigate(`/estimate/${dealId}/${companyId}`)
                                }
                                style={{
                                  width: "36px",
                                  height: "36px",
                                  borderRadius: "10px",
                                  padding: "0px",
                                }}
                              >
                                <PlusIcon style={{ color: "#151718" }} />
                              </Button>
                            )}
                          </h3>
                          <Button
                            htmlType="button"
                            className="outlined-btn"
                            type="primary"
                            onClick={(e) => e.stopPropagation()}
                            disabled={true}
                          >
                            Documents <DocumentIcon />
                          </Button>
                        </div>
                      )}

                    <ProposalCards
                      setLoading={setLoading}
                      loading={loading}
                      proposalListData={proposalListData?.data}
                      dealsDetailData={dealsDetailData?.data}
                    />

                    {proposalListData?.data &&
                      proposalListData?.data?.length < 2 && (
                        <Card
                          className={
                            proposalListData?.data?.length === 0
                              ? "height_100 add_more_proposal"
                              : "add_more_proposal"
                          }
                        >
                          <div className="avatar">
                            <img
                              src="/images/potential-deals/add_proposal_icon.svg"
                              alt="avatar"
                            />
                          </div>
                          <h3 style={{ marginBottom: "8px" }}>
                            {proposalListData?.data?.length === 0
                              ? "Create estimate & proposal"
                              : "Create one more proposal"}
                          </h3>
                          <p
                            style={{
                              marginBottom: "16px",
                              fontSize: "15px",
                              color: "#6C7478",
                            }}
                          >
                            Set the scope of work, create an estimate, and send
                            the proposal.
                          </p>

                          {dealsDetailData?.data?.status !== "lost" && (
                            <Button
                              htmlType="button"
                              className="outlined-btn"
                              type="primary"
                              onClick={() =>
                                navigate(`/estimate/${dealId}/${companyId}`)
                              }
                            >
                              <PlusIcon /> Create new proposal
                            </Button>
                          )}
                        </Card>
                      )}
                  </div>
                </div>
              </Card>

              <Card
                className="checklistCardWrapper"
                style={{ display: "none" }}
              >
                <div className="checklist">
                  <div className="title">
                    <h3>Checklist</h3>
                  </div>
                  <div className="content">
                    <Card className="checklistCard">
                      <div className="checkList_listing">
                        <Checkbox>Complete estimate</Checkbox>

                        <div className="checklistFooter">
                          <DatePicker
                            onChange={handleChecklistDateChange("estimate")}
                            value={
                              checklistDates.estimate
                                ? dayjs(checklistDates.estimate)
                                : null
                            }
                            format={"ddd, MMM DD"}
                            allowClear={false}
                            suffixIcon={<CalendarIcon />}
                            className={
                              checklistDates.estimate
                                ? "checklistDatePicker"
                                : "noDateSelected"
                            }
                          />
                          <div style={{ marginLeft: 8 }}>
                            <img
                              src="/images/dummy/checkList_dp_1.png"
                              alt=""
                              style={{
                                width: "28px",
                                height: "28px",
                                borderRadius: "100px",
                              }}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="checkList_listing">
                        <Checkbox>Approve estimate & proposal</Checkbox>

                        <div className="checklistFooter">
                          <DatePicker
                            onChange={handleChecklistDateChange("approval")}
                            value={
                              checklistDates.approval
                                ? dayjs(checklistDates.approval)
                                : null
                            }
                            format={"ddd, MMM DD"}
                            allowClear={false}
                            suffixIcon={<CalendarIcon />}
                            className={
                              checklistDates.approval
                                ? "checklistDatePicker"
                                : "noDateSelected"
                            }
                          />
                          <div style={{ marginLeft: 8 }}>
                            <img
                              src="/images/dummy/checkList_dp_2.png"
                              alt=""
                              style={{
                                width: "28px",
                                height: "28px",
                                borderRadius: "100px",
                              }}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="checkList_listing">
                        <Checkbox> Send proposal </Checkbox>

                        <div className="checklistFooter">
                          <DatePicker
                            onChange={handleChecklistDateChange("send")}
                            value={
                              checklistDates.send
                                ? dayjs(checklistDates.send)
                                : null
                            }
                            format={"ddd, MMM DD"}
                            allowClear={false}
                            suffixIcon={<CalendarIcon />}
                            className={
                              checklistDates.send
                                ? "checklistDatePicker"
                                : "noDateSelected"
                            }
                          />
                          <div style={{ marginLeft: 8 }}>
                            <img
                              src="/images/dummy/checkList_dp_1.png"
                              alt=""
                              style={{
                                width: "28px",
                                height: "28px",
                                borderRadius: "100px",
                              }}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="checkList_listing">
                        <Checkbox> Win contract </Checkbox>

                        <div className="checklistFooter">
                          <DatePicker
                            onChange={handleChecklistDateChange("win")}
                            value={
                              checklistDates.win
                                ? dayjs(checklistDates.win)
                                : null
                            }
                            format={"ddd, MMM DD"}
                            allowClear={false}
                            suffixIcon={<CalendarIcon />}
                            className={
                              checklistDates.win
                                ? "checklistDatePicker"
                                : "noDateSelected"
                            }
                          />
                          <div style={{ marginLeft: 8 }}>
                            <img
                              src="/images/dummy/checkList_dp_1.png"
                              alt=""
                              style={{
                                width: "28px",
                                height: "28px",
                                borderRadius: "100px",
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </Card>
                  </div>
                </div>
              </Card>
            </div>
          </Col>

          <DealsSidebar sidebarData={dealsDetailData?.data} />
        </Row>
      </div>
    </DashboardTemplate>
  );
}
